var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailiconSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12.114,
    viewBox: "0 0 17 12.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_3_",
    "data-name": "email (3)",
    transform: "translate(-2.08 -10.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13734",
    "data-name": "Path 13734",
    d: "M16.665,22.794H4.495A2.418,2.418,0,0,1,2.08,20.379V13.095A2.418,2.418,0,0,1,4.495,10.68H16.665a2.418,2.418,0,0,1,2.415,2.415v7.284a2.418,2.418,0,0,1-2.415,2.415ZM4.495,11.532a1.563,1.563,0,0,0-1.563,1.563v7.284a1.563,1.563,0,0,0,1.563,1.563H16.665a1.563,1.563,0,0,0,1.563-1.563V13.095a1.563,1.563,0,0,0-1.563-1.563Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13735",
    "data-name": "Path 13735",
    d: "M11.154,22.26A2.418,2.418,0,0,1,9.7,21.774L3.063,16.757a.426.426,0,1,1,.514-.679L10.211,21.1a1.577,1.577,0,0,0,1.886,0l6.634-5.023a.426.426,0,1,1,.514.679l-6.634,5.017a2.418,2.418,0,0,1-1.457.486Z",
    transform: "translate(-0.574 -3.796)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13736",
    "data-name": "Path 13736",
    d: "M3.095,35.243A.426.426,0,0,1,2.81,34.5l5.227-4.662a.427.427,0,0,1,.568.636L3.379,35.135A.415.415,0,0,1,3.095,35.243Zm15.813,0a.415.415,0,0,1-.284-.108L13.4,30.473a.427.427,0,0,1,.568-.636L19.188,34.5a.426.426,0,0,1-.284.744Z",
    transform: "translate(-0.421 -13.637)",
    fill: "#222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailiconSolid);
export default __webpack_public_path__ + "static/media/mailiconSolid.99e998e8.svg";
export { ForwardRef as ReactComponent };